import React, { useState } from 'react'
import { Badge, Button, Input, InputGroup, InputGroupAddon } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons'

const MAX_ZONES = 20

const CoverageZonesInput = ({ value = [], onChange, invalid, placeholder = 'Ej: Chacao, Los Palos Grandes' }) => {
  const [draft, setDraft] = useState('')

  const addZones = (text) => {
    const next = [...value]
    text
      .split(',')
      .map((zone) => zone.trim())
      .filter(Boolean)
      .forEach((zone) => {
        const exists = next.some((current) => current.toLowerCase() === zone.toLowerCase())
        if (!exists && next.length < MAX_ZONES) next.push(zone.slice(0, 80))
      })
    onChange(next)
    setDraft('')
  }

  const removeZone = (zone) => onChange(value.filter((current) => current !== zone))

  return (
    <>
      <InputGroup>
        <Input
          value={draft}
          invalid={invalid}
          placeholder={placeholder}
          disabled={value.length >= MAX_ZONES}
          onChange={({ target }) => {
            if (target.value.includes(',')) {
              addZones(target.value)
            } else {
              setDraft(target.value)
            }
          }}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault()
              addZones(draft)
            }
            if (event.key === 'Backspace' && !draft && value.length) {
              removeZone(value[value.length - 1])
            }
          }}
          onBlur={() => draft.trim() && addZones(draft)}
        />
        <InputGroupAddon addonType="append">
          <Button color="falcon-default" onClick={() => addZones(draft)} disabled={!draft.trim()}>
            <FontAwesomeIcon icon={faPlus} className="mr-1" />
            Agregar
          </Button>
        </InputGroupAddon>
      </InputGroup>
      <div className="d-flex flex-wrap mt-2" style={{ gap: 6 }}>
        {value.map((zone) => (
          <Badge key={zone} color="soft-primary" pill className="d-inline-flex align-items-center fs--1 px-3 py-2">
            {zone}
            <button
              type="button"
              className="btn btn-link p-0 ml-2 text-primary"
              onClick={() => removeZone(zone)}
              title={`Quitar ${zone}`}
              style={{ lineHeight: 1 }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </Badge>
        ))}
      </div>
    </>
  )
}

export default CoverageZonesInput
